<div class="card">
    <div class="card-header">
        Relievers
    </div>
    <div class="card-body" style="overflow: auto; width: 100%;">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;">#</th>
                    <th>Employee</th>
                    <th style="width: 5px;">Add</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let Reliever of Relievers; let i = index">
                    <th scope="row" style="width: 5px;">{{i+1}}</th>
                    
                    <td>
                        <div class="row" style="align-items: start; width: 350px;">
                            <div class="col-2">
                                <img *ngIf="Reliever['EmployeeImage'] != null && Reliever['EmployeeImage'] != '' && Reliever['EmployeeImage'] != 'https://webftp.maxus.co.in/PROD/Photo/'"
                                    mat-card-image class="userImage" (click)="common.FullImage('',{ProfileImage:Reliever['EmployeeImage'],
                                    Name: Reliever['FullName'],
                                    Code: Reliever['EmpCode']})" [src]="Reliever['EmployeeImage']" />

                                <!-- <img *ngIf="Reliever['EmployeeImage'] == ''"
                                    mat-card-image class="userImage" (click)="common.FullImage('',{ProfileImage:Reliever['EmployeeImage'],
                                    Name: Reliever['FullName'],
                                    Code: Reliever['EmpCode']})" [src]="Reliever['EmployeeImage']" /> -->

                                <div *ngIf="Reliever['EmployeeImage'] == null || Reliever['EmployeeImage'] == '' || Reliever['EmployeeImage'] == 'https://webftp.maxus.co.in/PROD/Photo/'"
                                    (click)="common.FullImage('',{ProfileImage:common.PhotoLink(Reliever['EmployeeImage'])} )"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(Reliever['FullName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-10">
                                <div class="d-flex justify-content-between">
                                    <span class="text-label">{{Reliever['FullName']}}</span>
                                </div>
                                <span class="text-label-light">#{{Reliever['EmpCode']}}</span>                        
                            </div>
                        </div>
                    </td>
                    <td style="width: 5px;">
                        <button class="btn btn-primary btn-sm" (click)="Add(Reliever)"><i class="bi bi-plus"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button class="btn btn-primary btn-sm" (click)="close()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
